import { afterNextRender, Component, ElementRef, forwardRef, HostBinding, input, linkedSignal, output, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractControl } from '../abstract-control/abstract-control';
import { Button } from '../../button/button';
import { CSSValuePipe } from '@pipes/css-value-pipe';

@Component({
  selector: 'app-input-search',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, CSSValuePipe, Button],
  templateUrl: './input-search.html',
  styleUrls: ['./../abstract-control/abstract-control.scss', './input-search.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSearch),
      multi: true,
    },
  ],
})
export class InputSearch extends AbstractControl<string | undefined, string> {
  // View refs
  $inputElement = viewChild.required<ElementRef<HTMLInputElement>>('input');

  // Inputs
  override $value = input<string | undefined>(undefined, { alias: 'value' });
  $_value = linkedSignal(this.$value);
  $inputWidth = input<string>('100%', { alias: 'inputWidth' });
  $hostWidth = input<string>('auto', { alias: 'hostWidth' });
  $placeholder = input<string>('', { alias: 'placeholder' });
  $autofocus = input<boolean>(false, { alias: 'autofocus' });

  // Outputs
  override valueChange = output<string>();

  // Signals / atributos
  override $controlValue = signal<string>('');

  // Bindings
  @HostBinding('style.width')
  get hostWidth(): string { return this.$hostWidth(); }

  // Verificar si se emitirá el valor al iniciar
  constructor () {
    super();
    afterNextRender(() => {
      if (this.$autofocus())
        this.$inputElement().nativeElement.focus();

      if (this.$emitAtStart()) {
        const value = (this.$value() !== undefined ? this.$value() : this.$controlValue()) as string;
        this.valueChange.emit(value);
      }
    });
  }

  // Maneja el evento de entrada de texto
  onValueChange(event: Event) {
    const newValue = (event.target as HTMLInputElement).value;
    if (this.$value() !== undefined)
      this.$_value.set(newValue);
    this.updateValue(newValue);
    this.valueChange.emit(newValue);
  }

  // Maneja el evento de cambio de valor desde el input
  onClear() {
    this.updateValue('', false);
    if (this.$value() !== undefined)
      this.$_value.set('');
    this.$inputElement().nativeElement.focus();
    this.valueChange.emit('');
  }
}
